import React, { Component } from "react";
import { connect } from "react-redux";
import Axios from "axios-https-proxy-fix";
import UploadPreview from "../../../components/UploadPreview/UploadPreview.js";
import "./ApplicationSettings.scss";
import { Dropdown } from "semantic-ui-react";
import SettingsWrapper from "../../../components/Settings/SettingsWrapper";
import translator from "../../../utils/translator";
import { saveSettings } from "../../../utils/checkSettings";

export class ApplicationSettings extends Component {
	emptyState = () => {
		return {
			warehouseSettings: {},
			warehouse: "",
			settingsLoaded: 0,
			response: {},

			hide_model_number: 0,
			hide_standard_pricing: 0,
			show_quote_list_price: 0,

			send_room_titles_to_trend: 0,
			quote_colour: "FF000000",
			show_homescreen_image: 0,
			existing_logo: "",
			logo: "",
			logokey: Date.now(),
			"delete-logo": 0
		};
	};

	state = this.emptyState();

	updateState = (key, val) => {
		this.setState(state => ({
			[key]: val
		}));
	};

	toggleState = key => {
		this.setState(state => ({
			[key]: state[key] ? 0 : 1
		}));
	};

	// ============= AJAX FUNCTIONS =============

	callAjax = async (url, data) => {
		data.trendId = localStorage.getItem("trendId");
		data.token = localStorage.getItem("token");

		let APIResponse = await Axios.post(url, data);
		if (APIResponse.data.hasOwnProperty("error")) {
			this.updateState("response", { error: APIResponse.data.error });
			return false;
		}
		this.updateState("response", {});
		return APIResponse.data;
	};

	componentDidMount = async () => {
		this.setSettings();
	};

	setSettings = async () => {
		let ajaxURL = this.props.APIUrl + "/settings/get-user-settings";
		let settings = await this.callAjax(ajaxURL, {});

		saveSettings(settings);

		this.setState(state => ({
			warehouse: null,
			settingsLoaded: 1,
			response: {},

			hide_model_number: settings.hide_model_number,
			hide_standard_pricing: settings.hide_standard_pricing,
			show_quote_list_price: settings.show_quote_list_price,

			send_room_titles_to_trend: settings.send_room_titles_to_trend,
			quote_colour: settings.quote_colour ? settings.quote_colour : "FF000000",
			show_homescreen_image: settings.show_homescreen_image,
			existing_logo: settings.logo ? process.env.REACT_APP_PHP_API + "/images/_consultant-logos/" + settings.logo : "",
			"delete-logo": 0
		}));
	};

	submit = async () => {
		let ajaxURL = this.props.APIUrl + "/settings/save-user-settings";
		let data = { ...this.state };
		delete data.warehouseSettings;
		delete data.settingsLoaded;
		delete data.response;
		if (!data["delete-logo"]) delete data["delete-logo"];

		this.updateState("response", { loadingbar: translator("Misc", "saving_label") });

		let response = await this.callAjax(ajaxURL, data);
		if (!response) return;

		await this.setSettings();
		this.updateState("response", response);
	};

	// ============= RENDER FUNCTIONS =============

	renderResponse = response => {
		if (Object.keys(response).length === 0) return null;
		let key = "error";
		if (response.hasOwnProperty("success")) key = "success";
		if (response.hasOwnProperty("loadingbar")) key = "loadingbar";
		let cardClass = "card user-profile-card response-" + key;
		return (
			<div className={cardClass}>
				<div class="card-body">{response[key]}</div>
			</div>
		);
	};

	renderSettings = state => {
		let app_rows = [
			["hide_model_number", translator("Admin Consultant Settings", "hide_model_number_all")],
			["hide_standard_pricing", translator("Admin Consultant Settings", "hide_standard_pricing")],
			["show_quote_list_price", translator("Admin Consultant Settings", "show_quote_list_price")]
		];
		let room_title_rows = [
			translator("Admin Consultant Settings", "send_room_titles_to_trend_ask"),
			translator("Admin Consultant Settings", "send_room_titles_to_trend_do_not_show"),
			translator("Admin Consultant Settings", "send_room_titles_to_trend_show")
		];

		let colours = [
			{
				value: "FF000000",
				text: (
					<span>
						<span className="office-black"></span>{translator("Application Settings", "black")}
					</span>
				)
			},
			{
				value: "FFFFFFFF",
				text: (
					<span>
						<span className="office-white"></span>{translator("Application Settings", "white")}
					</span>
				)
			},
			{
				value: "FFFF0000",
				text: (
					<span>
						<span className="office-red"></span>{translator("Application Settings", "red")}
					</span>
				)
			},
			{
				value: "FF800000",
				text: (
					<span>
						<span className="office-dark-red"></span>{translator("Application Settings", "dark-red")}
					</span>
				)
			},
			{
				value: "FF0000FF",
				text: (
					<span>
						<span className="office-blue"></span>{translator("Application Settings", "blue")}
					</span>
				)
			},
			{
				value: "FF000080",
				text: (
					<span>
						<span className="office-dark-blue"></span>{translator("Application Settings", "dark-blue")}
					</span>
				)
			},
			{
				value: "FF00FF00",
				text: (
					<span>
						<span className="office-green"></span>{translator("Application Settings", "green")}
					</span>
				)
			},
			{
				value: "FF008000",
				text: (
					<span>
						<span className="office-dark-green"></span>{translator("Application Settings", "dark-green")}
					</span>
				)
			},
			{
				value: "FFFFFF00",
				text: (
					<span>
						<span className="office-yellow"></span>{translator("Application Settings", "yellow")}
					</span>
				)
			},
			{
				value: "FF808000",
				text: (
					<span>
						<span className="office-dark-yellow"></span>{translator("Application Settings", "dark-yellow")}
					</span>
				)
			}
		];
		return (
			<div class="card user-profile-card">
				<div class="card-body application-settings">
					<h2 class="setting-header">{translator("Admin Consultant Settings", "application_label")}:</h2>

					<table class="table table-bordered search-results-table checkbox-table">
						<tbody>
							{app_rows.map(row => {
								return (
									<tr key={row[0]}>
										<td>
											<h3 class="application-settings-sub-header">{row[1]}</h3>
										</td>
										<td class="settings-checkbox-td">
											<input type="checkbox" class="dn" id={row[0]} checked={state[row[0]] ? state[row[0]] : 0} onChange={() => this.toggleState(row[0])} />
											<label class="settings-label" htmlFor={row[0]}>
												<div class="settings-label-icon">&#10003;</div>
											</label>
										</td>
									</tr>
								);
							})}
						</tbody>
					</table>

					<h2 class="setting-header">{translator("Admin Consultant Settings", "room_title_section_title")}:</h2>

					<table class="table table-bordered search-results-table checkbox-table">
						<tbody>
							{room_title_rows.map((title, index) => {
								return (
									<tr key={index}>
										<td>
											<h3 class="application-settings-sub-header">{title}</h3>
										</td>
										<td class="settings-checkbox-td">
											<input type="radio" name="room_titles" class="dn" id={"room_titles_" + index} checked={state.send_room_titles_to_trend === index} onChange={() => this.updateState("send_room_titles_to_trend", index)} />
											<label class="settings-label" htmlFor={"room_titles_" + index}>
												<div class="settings-label-icon">&#10003;</div>
											</label>
										</td>
									</tr>
								);
							})}
						</tbody>
					</table>

					<h2 class="setting-header">{translator("Admin Consultant Settings", "quote_colour_label")}:</h2>

					<Dropdown placeholder="SELECT ONE" selection options={colours} value={state.quote_colour} onChange={(e, d) => this.updateState("quote_colour", d.value)} />

					<h2 class="setting-header">{translator("Admin Edit Partner", "file_type_logo")}:</h2>

					<div class="custom-checkbox-wrapper mb1">
						<input type="checkbox" class="dn" id="show_homescreen_image" checked={state.show_homescreen_image ? 1 : 0} onChange={() => this.toggleState("show_homescreen_image")} />
						<label class="custom-checkbox-label" htmlFor={"show_homescreen_image"}>
							<div class="label-box"></div>
							<div class="label-message">{translator("Admin Consultant Settings", "show_homescreen_image_label")}</div>
						</label>
					</div>

					<UploadPreview key={state.logokey} preview={state.existing_logo} saveImage={this.updateState} stateKey={"logo"} />

					<div class="custom-checkbox-wrapper">
						<input type="checkbox" class="dn" id="delete-logo" checked={state["delete-logo"] ? 1 : 0} onChange={() => this.toggleState("delete-logo")} />
						<label class="custom-checkbox-label" htmlFor={"delete-logo"}>
							<div class="label-box"></div>
							<div class="label-message">{translator("Misc", "delete_label")}</div>
						</label>
					</div>

					<div>
						<button type="button" class="btn btn-primary pbook-settings-submit" onClick={this.submit}>
							{translator("Admin Consultant Settings", "submit_btn")}
						</button>
					</div>
				</div>
			</div>
		);
	};

	render() {
		let state = this.state;

		let main = (
			<>
				{state.settingsLoaded ? this.renderSettings(state) : null}
				{this.renderResponse(state.response)}
			</>
		);

		return (
			<SettingsWrapper header={translator("Admin Menu", "application_settings_title")} main={main} />
		);
	}
}

const mapStateToProps = state => ({
	APIUrl: state.APIUrl
});

const mapDispatchToProps = {};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ApplicationSettings);
